module.exports = __webpack_public_path__ + "static/media/toyota.c60e1a01.png";